/** @format */

import React from 'react'

import './style.css'

export default function Images(props) {
	return (
		<picture className={props.classContent}>
			<source srcSet={props.webp} type='image/webp' />
			<source srcSet={props.jp2} type='image/jp2' />
			<source srcSet={props.jxr} type='image/vnd.ms-photo' />
			<img src={props.default} alt={props.title} title={props.title} />
		</picture>
	)
}
